<template>
  <div class="hello" v-if = "isAlive">
    <slick
	  ref="slick"
	  :options="slickOptions"
	  @afterChange="handleAfterChange"
	  @beforeChange="handleBeforeChange"
	  @breakpoint="handleBreakpoint"
	  @destroy="handleDestroy"
	  @edge="handleEdge"
	  @init="handleInit"
	  @reInit="handleReInit"
	  @setPosition="handleSetPosition"
	  @swipe="handleSwipe"
	  @lazyLoaded="handleLazyLoaded"
	  @lazyLoadError="handleLazeLoadError">
	  <a v-for = "obj in dataList" @click="getUrl(obj)" href="javascript:void(0);"><img :src="obj.image" alt="" /></a>
	</slick>
  </div>
</template>

<script>
import Slick from 'vue-slick'
import '../../../node_modules/slick-carousel/slick/slick.css'

export default {
  name: 'Lx',
  props: ['arr','switchTime'],
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
      	autoplay:true,
        autoplaySpeed:5000,
      	dots:true,
      	arrows:false
	    },
      dataList:[],
      isAlive:true
    }
  },
  methods: {
    //判断手机终端
    checkIsPhone(urla, urli, urlw) {
        // console.log(urla);
        // console.log(urli);
        // console.log(urlw);
        //posa-安卓标识, posi-苹果标识, posn-其它标识, posw-微信标识, urla-安卓链接, urli-苹果链接, urln-其它链接, urlw-微信链接
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        var isWeixin = window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i);//微信
        var a;

        if (isAndroid && isWeixin != 'micromessenger') {
            a = urla;
        } else if (isiOS && isWeixin != 'micromessenger') {
            a = urli;
        } else if (isWeixin == 'micromessenger') {
            a = urlw;
        }
        else{
          a = urlw;
        }
        // console.log(a);
        return a;
    },
    getUrl(obj){
        window.location.href = obj.url;
        // if(obj.url_type == 2){
        //   const type = localStorage.getItem('plat');
        //   if(type == 1){
        //     JsPhone.jumpPageUrl(obj.url);
        //     return;
        //   }
        //   else{
        //     var ssssss = {
        //       jsonrpc: 2.0,
        //       method: "openCustomScheme",
        //       params: obj.url
        //     };
        //     window.webkit.messageHandlers.nativeCallBack.postMessage(ssssss);
        //     //this.$router.push('/reUrl');
        //     return;
        //   }
        // }

        // if(typeof(obj.url) != 'undefined' && obj.url != '')
        //   window.location.href = obj.url;
        //return this.checkIsPhone(urlw, urlw, urlw);
    },
  	onSwipeLeft () {
  		//console.log('left');
  	},
  	onSwipeRight () {
  		//console.log('right');
  	},
  	next() {
        this.$refs.slick.next();
    },
    prev() {
        this.$refs.slick.prev();
    },
    reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
            this.$refs.slick.reSlick();
        });
    },
    // Events listeners
    handleAfterChange(event, slick, currentSlide) {
        //console.log('handleAfterChange', event, slick, currentSlide);
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
        //console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
    },
    handleBreakpoint(event, slick, breakpoint) {
        //console.log('handleBreakpoint', event, slick, breakpoint);
    },
    handleDestroy(event, slick) {
        //console.log('handleDestroy', event, slick);
    },
    handleEdge(event, slick, direction) {
        //console.log('handleEdge', event, slick, direction);
    },
    handleInit(event, slick) {
        //console.log('handleInit', event, slick);
        //console.log(slick);
    },
    handleReInit(event, slick) {
        //console.log('handleReInit', event, slick);
    },
    handleSetPosition(event, slick) {
        //console.log('handleSetPosition', event, slick);
    },
    handleSwipe(event, slick, direction) {
        //console.log('handleSwipe', event, slick, direction);
    },
    handleLazyLoaded(event, slick, image, imageSource) {
        //console.log('handleLazyLoaded', event, slick, image, imageSource);
    },
    handleLazeLoadError(event, slick, image, imageSource) {
        //console.log('handleLazeLoadError', event, slick, image, imageSource);
    },
    reload () {
      //console.log(1);
      this.isAlive = false;

      var that = this;
      that.$nextTick(function(){
        that.isAlive = true;
      });
    }
  },
  created () {
    if(typeof(this.arr) != "undefined"){
      this.dataList = this.arr;
      const that = this;
      setTimeout(function(){
        //console.log(that.dataList);
      },2000);
    }
    if(typeof(this.switchTime) != 'undefined')
      this.slickOptions.autoplaySpeed = this.switchTime;

    //this.$refs.slick.reSlick();
    //this.reload();
    
  },
  watch:{
        dataList(val, oldVal){//普通的watch监听
            //console.log(val);
            //console.log(oldVal);
            this.reload();
        }
        // dataList:{ //深度监听，可监听到对象、数组的变化
        //   handler (newV, oldV) {
        //     // do something, 可使用this
        //     console.log(oldV);
        //     console.log(newV);
        //   },
        //   deep:true
        // }
    }
}
</script>

<style scoped>
</style>
<style>
.slick-slide{height:50%;}
.slick-slide img
{
    width:100%;
}
.slick-dots{
    position: absolute;
    bottom: 16px;
    width: 100%;
    font-size: 0;
    text-align: center;
}

.slick-dots li{
    display: inline-block;
    width: 12px;
    height:12px;
    background-color: rgba(255,255,255,0.5);
    border-radius:200px;
    margin:0 6px;
}

.slick-dots li.slick-active{
    background-color: #fff
}

.slick-dots li button{
    display: none
}    
</style>











// WEBPACK FOOTER //
// src/components/common/Lx.vue